'use strict'

const { TextEncoder } = require('web-encoding')

module.exports = TextEncoder
